import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, errMsg, fmtDate, fmtDay } from "@/lib/api";
import { PrintSheet, PrintRow } from "@/components/forms/PrintSheet";
import { MINUTES_SECTIONS } from "@/lib/minutes";

export default function MinutesPrint() {
  const { id } = useParams();
  const [m, setM] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/minutes/${id}`).then((r) => setM(r.data)).catch((e) => setErr(errMsg(e))); }, [id]);
  if (err) return <div className="rounded-lg border border-rose-200 bg-rose-50 p-6 text-rose-700" data-testid="minutes-print-error">{err}</div>;
  if (!m) return <div className="h-40 animate-pulse rounded-lg bg-slate-100" />;
  const f = m.fields;
  const att = m.attendance || [];
  const present = att.filter((a) => a.status === "present");
  const absent = att.filter((a) => a.status === "absent");
  const val = (k) => {
    if (k === "date") return f.date ? fmtDay(f.date) : "";
    if (k === "adoption_by" && m.previous) return `${f.adoption_by || "—"}\n(Minutes ${m.previous.number}${m.previous.fields?.date ? ` of ${fmtDay(m.previous.fields.date)}` : ""})`;
    if (k === "signature_name" && f.signature_name && m.signature_at) return `${f.signature_name}\nSigned ${fmtDate(m.signature_at)}`;
    return f[k];
  };
  return (
    <PrintSheet back={`/minutes/${id}`} kind="Minutes of MIT" number={m.number} title={`MIT Minutes${f.date ? ` · ${fmtDay(f.date)}` : ""}`}
      footer={<><span>Status: {m.status === "finalised" ? `Finalised ${fmtDate(m.finalised_at)} by ${m.finalised_by_name}` : "DRAFT — not finalised"}</span><span>Recorded by {m.created_by_name}</span></>}>
      {m.status !== "finalised" && <div className="mb-3 rounded border-2 border-amber-500 px-3 py-1.5 text-xs font-bold text-amber-700" data-testid="minutes-print-draft">DRAFT</div>}
      {MINUTES_SECTIONS.map((s) => (
        <div key={s.key}>
          <PrintRow label={s.label} testid={`minutes-print-${s.key}`}>{val(s.key)}</PrintRow>
          {s.key === "moderator" && att.length > 0 && <>
            <PrintRow label={`Present (${present.length})`} testid="minutes-print-present">{present.map((a, i) => `${i + 1}. ${a.name}`).join("\n")}</PrintRow>
            <PrintRow label={`Absent (${absent.length})`} testid="minutes-print-absent">{absent.map((a, i) => `${i + 1}. ${a.name}`).join("\n")}</PrintRow>
          </>}
        </div>
      ))}
    </PrintSheet>
  );
}
